import { NavLink } from "react-router-dom";
import Button from "./Button";
import ArrowUpRight from "./icons/ArrowUpRight";
import AppearOnScroll from "./AppearOnScroll";

function Hero() {
    let about = require("../about.json");
    return (
      <div className="relative overflow-hidden w-full">
        <section className="relative flex flex-col items-start  gap-8 w-full md:gap-12">
        
            <div className="flex flex-col items-start w-full place-content-between gap-2 md:flex-row md:items-end  md:gap-0">
            <AppearOnScroll delay={0.1} y={100}>
                <div className="flex w-full">
                    <h1 className="font-display font-medium text-4xl md:text-5xl lg:text-7xl xl:text-8xl text-left leading-relaxed">Lisanne Verbeet<br></br>Portfolio</h1>
                </div>
                </AppearOnScroll>
                <AppearOnScroll y={100} delay={0.2}>
                <div className="flex items-center gap-8  max-w-xl">
                    <p className="font-body font-medium text-lg md:text-2xl text-wrap text-right">Master student Industrial Design</p>
                </div>
                </AppearOnScroll>
            </div>
            <AppearOnScroll y={100} delay={0.4} duration={0.3}>
            <div className="flex items-center w-full ">
                <div className="hidden md:block">
                <img fetchpriority="high" src={`/img/Home-banner.png`} alt="banner" className="rounded-image"/>
                </div>
                <div className="block md:hidden">
                <img fetchpriority="high" src={`/img/banner-mobile.png`} alt="banner" className="rounded-image"/>
                </div>
                   
            </div>
            </AppearOnScroll>

            <AppearOnScroll delay={0.5}>
            <div className="flex flex-col w-full items-end ">
                <div className="flex flex-col items-start md:w-40 gap-6">
                   <p className="text-left text-body font-body font-regular leading-relaxed text-base lg:text-lg xl:text-xl">{about.summary}</p> 
                   <NavLink to={'/About'}>
                   <Button icon={ArrowUpRight} iconPosition="right" variant="primary" className='group'>More about me</Button>
                   </NavLink>
                   
                </div>
            </div>
            </AppearOnScroll>
        </section>
      </div>
      
    );
  }
  
  export default Hero;